var map = {
	"./calculator_controller.js": 75,
	"./contact_controller.js": 76,
	"./diary_controller.js": 77,
	"./home_controller.js": 78,
	"./preview_controller.js": 79,
	"./recipes_controller.js": 80,
	"./reviews_controller.js": 81,
	"./successstories_controller.js": 82,
	"./training_controller.js": 83,
	"./updates_controller.js": 84,
	"./users_controller.js": 85,
	"./welcome_controller.js": 86
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74;